// extracted by mini-css-extract-plugin
export default {"container":"subscription-block_container__2gEpY","card":"subscription-block_card__2pgkw","inner":"subscription-block_inner__1VCBn"};